import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import logoSm from "../assets/images/Group 4222.png";
import logoCheckAuto from "../assets/images/logoCheckAuto.png"; // Logo large
import { Container } from "reactstrap";
import iconDashboard from "../assets/images/IconDashboard.png";
import iconVehicle from "../assets/images/IconVehicle.png";
import iconInspection from "../assets/images/IconInspection.png";
import iconChauffeur from "../assets/images/IconChauffeur.png";
import iconFormulaire from "../assets/images/IconFormulaire.png";
import iconRapel from "../assets/images/IconRapel.png";
import iconCarte from "../assets/images/IconCarte.png";
import iconIncident from "../assets/images/IconIncdent.png";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import logoDark from "../assets/login_page_assets/images/check-auto.logo.png";
import settingsIcons from "../assets/images/settingsIcons.png";
import fleetFix from "../assets/images/FleetFix.png";
import { QuestionCircleOutlined } from "@ant-design/icons";
const Sidebar = () => {
  const [isSidebarSmall, setIsSidebarSmall] = useState(false); // État pour vérifier si le sidebar est réduit
  const [buttonFontSize, setButtonFontSize] = useState("6px"); // Taille initiale du texte du bouton
  const location = useLocation(); // Pour récupérer l'URL actuelle
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false); 
  const [isHovered, setIsHovered] = useState(false); // État pour vérifier si le sidebar est survolé
  useEffect(() => {
    const verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", () => {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };
  // Fonction pour basculer l'état du menu Administration
  const toggleAdminMenu = () => {
    setIsAdminMenuOpen(!isAdminMenuOpen);
  };
  return (
    
    <div className="app-menu navbar-menu"
    onMouseEnter={() => setButtonFontSize("16px")} // Augmente la taille du texte à 16px
    onMouseLeave={() => setButtonFontSize("4px")} // Réduit la taille du texte à 4px
      >
       <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            title="Fixer le menu"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover mt-1"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
      <div className="navbar-brand-box">
        <Link to="#" className="logo logo-dark">
          <span className="logo-sm">
            <img src={logoSm} alt="" height="22" />
          </span>
          <span className="logo-lg">
            <img src={logoDark} alt="" height="17" />
          </span>
        </Link>

        <Link to="/" className="logo">
          <span className="logo-lg text-center">
            <img
              src={fleetFix}
              style={{
                width: "103px",
                height: "22px",
                marginLeft: "40px",
                marginTop: "20px",
              }}
              alt="Check"
              className="login-icon"
            />
          </span>
        </Link>

        <hr
          style={{
            marginTop: "5px",
            color: "#616161",
            height: "1px",
            border: "1px",
            backgroundColor: "#616161",
          }}
        />
      </div>

      <SimpleBar id="scrollbar" className="h-100">
        <Container fluid>
          <ul className="navbar-nav" id="navbar-nav">
            <li
              className={`nav-item ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
            >
              <Link
                to="/dashboard"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconDashboard}
                  alt="Dashboard Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/dashboard"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "16px",
                    color:
                      location.pathname === "/dashboard"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Dashboard
                </span>
              </Link>
            </li>

            <li
              className={`nav-item ${
                location.pathname === "/chauffeurs" ? "active" : ""
              }`}
            >
              <Link
                to="/chauffeurs"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconChauffeur}
                  alt="Chauffeur Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/chauffeurs"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />{" "}
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/chauffeurs"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Chauffeurs
                </span>
              </Link>
            </li>
            
            <li
              className={`nav-item ${
                location.pathname === "/vehicules" ? "active" : ""
              }`}
            >
              <Link
                to="/vehicules"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconVehicle}
                  alt="Vehicule Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/vehicules"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "16px",
                    color:
                      location.pathname === "/vehicules"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Vehicles
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/inspection" ? "active" : ""
              }`}
            >
              <Link
                to="/inspection"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconInspection} // Chemin de l'image
                  alt="Inspection Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/inspection"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/inspection"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Inspections
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/incidents" ? "active" : ""
              }`}
            >
              <Link
                to="/incidents"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconIncident} // Chemin de ton image
                  alt="Incident Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/incidents"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/incidents"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Incidents
                </span>
              </Link>
            </li>
            
            <li
              className={`nav-item ${
                location.pathname === "/formulaires" ? "active" : ""
              }`}
            >
              <Link
                to="/formulaires"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconFormulaire}
                  alt="Formulaire Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/formulaires"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />{" "}
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/formulaires"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Formulaires
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/rappels" ? "active" : ""
              }`}
            >
              <Link
                to="/rappels"
                className="nav-link d-flex align-items-center"
              >
                <img
                  src={iconRapel}
                  alt="Rappel Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/rappels"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />{" "}
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/rappels"
                        ? "#FFFFFF"
                        : "#FFFFFFCC",
                  }}
                >
                  Rappels
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/cartes" ? "active" : ""
              }`}
            >
              <Link to="/cartes" className="nav-link d-flex align-items-center">
                <img
                  src={iconCarte}
                  alt="Carte Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/cartes"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />{" "}
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/cartes" ? "#FFFFFF" : "#FFFFFFCC",
                  }}
                >
                  Carte
                </span>
              </Link>
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/status" ? "active" : ""
              }`}
            >
              <Link to="/status" className="nav-link d-flex align-items-center">
                <img
                  src={iconCarte}
                  alt="Carte Icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    filter:
                      location.pathname === "/status"
                        ? "grayscale(0%)"
                        : "grayscale(100%)",
                  }}
                />{" "}
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/status" ? "#FFFFFF" : "#FFFFFFCC",
                  }}
                >
                  Status
                </span>
              </Link>
            </li>
            {/* Menu Administration */}
            <li
              className={`nav-item ${
                location.pathname.startsWith("/administration") ? "active" : ""
              }`}
            >
              <a
                className="nav-link d-flex align-items-center"
                onClick={toggleAdminMenu}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={settingsIcons} // Choisir une icône appropriée pour l'administration
                  alt="Administration Icon"
                  className="white-icon"
                  style={{
                    width: "15px",
                    height: "15px",
                    marginRight: "8px",
                    backgroundColor: " #FFFFFF",
                  }}
                />
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  Administration
                </span>
                {/* Icône de flèche indiquant l'ouverture du sous-menu */}
                {isAdminMenuOpen ? (
                  <FaChevronDown
                    style={{ marginLeft: "auto", fontSize: "12px" }}
                  />
                ) : (
                  <FaChevronRight
                    style={{ marginLeft: "auto", fontSize: "12px" }}
                  />
                )}
              </a>
              {isAdminMenuOpen && (
                <ul
                  id="administrationSubMenu"
                  className="navbar-nav"
                  style={{ paddingLeft: "20px" }}
                >
                  <li
                    className={`nav-item ${
                      location.pathname === "/roles" ? "active" : ""
                    }`}
                  >
                    <Link
                      to="/roles"
                      className="nav-link d-flex align-items-center"
                    >
                      <img
                        src={iconChauffeur} // Choisir une icône pour le rôle
                        alt="Roles Icon"
                        style={{
                          width: "15px",
                          height: "15px",
                          marginRight: "8px",
                        }}
                      />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        Rôles
                      </span>
                    </Link>
                  </li>
                  <li
                    className={`nav-item ${
                      location.pathname === "/utilisateurs" ? "active" : ""
                    }`}
                  >
                    <Link
                      to="/utilisateurs"
                      className="nav-link d-flex align-items-center"
                    >
                      <img
                        src={iconChauffeur} // Choisir une icône pour les utilisateurs
                        alt="Utilisateurs Icon"
                        style={{
                          width: "15px",
                          height: "15px",
                          marginRight: "8px",
                        }}
                      />
                      <span
                        style={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: "16px",
                        }}
                      >
                        Utilisateurs
                      </span>
                    </Link>
                  </li>
                  
                </ul> 
              )}
            </li>
            <li
              className={`nav-item ${
                location.pathname === "/aide" ? "active" : ""
              }`}
            >
              <Link to="/aide" className="nav-link d-flex align-items-center">
                <QuestionCircleOutlined/>
                <span
                  style={{
                    fontFamily: "Inter",
                    fontWeight: "400px",
                    fontSize: "16px",
                    color:
                      location.pathname === "/aide" ? "#FFFFFF" : "#FFFFFFCC",
                  }}
                >
                  Aide
                </span>
              </Link>
            </li>
            <div className="mt-deconnexion" style={{ position: "absolute", bottom: "5px", width: "100%", left: "0", padding: "0 10px"  }}>
              <Link to={process.env.PUBLIC_URL + "/logout"} className="dropdown-item">
                <button className="deconnexionButton"
                  style={{ fontSize: buttonFontSize}}
                >
                  Déconnexion
                </button>
              </Link>
            </div>
          </ul>
        </Container>
      </SimpleBar>

      <div className="sidebar-background"></div>
      <div className="vertical-overlay"></div>
    </div>
  );
};

export default Sidebar;
